module.exports = __webpack_public_path__ + "static/media/alteredLandscape.d07b9d9f.jpg";